export default {
  brandTag: "Play • Discover • Learn",
  navProfile: "Profile", navDashboard: "Dashboard", navStats: "User Stats", navAbout: "About Us",
  searchPh: "Search for something...",
  menuProfile: "Profile", menuLogout: "Log Out",
  notif1t: "New achievement unlocked! 🎉", notif1s: "2 hours ago",
  notif2t: "Reminder: project due in 3 days", notif2s: "Yesterday",
  notificationsEmpty: "No notifications yet",
  aboutTitle: "About LUDUS",
  aboutDesc: "LUDUS is an interactive learning platform that turns studying into an engaging experience through exploration, challenges, and game-based learning.",
  aboutEyebrow: "Learn differently",
  aboutHighlightGame: "3D virtual lab", aboutHighlightScenarios: "9 real scenarios", aboutHighlightFeedback: "Instant feedback",
  missionTitle: "Our Mission",
  missionText: "To make learning more interactive, accessible, and enjoyable — helping students build skills, gain confidence, and reach their full potential.",
  visionTitle: "Our Vision",
  visionText: "A future where every student can learn in a way that fits their unique style, interests, and goals — anytime, anywhere.",
  valuesTitle: "Our Values",
  valuesEyebrow: "The principles behind what we build",
  curiosityT: "Curiosity", curiosityD: "We believe in the power of questions.",
  inclusionT: "Inclusion", inclusionD: "Learning is for everyone.",
  innovationT: "Innovation", innovationD: "We grow through new ideas.",
  impactT: "Impact", impactD: "We're here to make a difference.",
  tagline: "Learning is better when you experience it.",
  dashHeroT: "Welcome back!",
  dashHeroD: "Pick up your learning journey right where you left off — new challenges and scenarios are waiting for you today.",
  botName: "Luddy", botSub: "Your smart learning companion", botGreet: "Hello! How can I help you?", botPh: "Ask me anything...",
  botOpen: "Open assistant", botClose: "Close assistant", botSend: "Send message", botDrag: "Drag to move the assistant",
  botHide: "Hide assistant", botShow: "Show assistant",
  journeyTitle: "Learning Journey",
  gameTitle: "Game Learning", gameDesc: "Interactive challenges and games",
  scenTitle: "Learning Through Scenarios", scenDesc: "Real-world situations to apply what you've learned",
  gameBadge: "Interactive game", scenarioBadge: "Real-world practice", playNow: "Play now", exploreNow: "Start scenario",
  deadlinesTitle: "Scenario learning tasks",
  streakLabel: "Login Streak", streakVal: "Day 1!", streakSub: "A great start — keep going!",
  recentsTitle: "Recent activity", noRecentActivity: "No activity yet — open a scenario and it will appear here.",
  perfTitle: "User Performance & Progress", perfLabel: "Performance %", progLabel: "Progress %",
  pName: "Aya Shafey", pUni: "British University in Egypt (BUE)",
  pFaculty: "Faculty of Informatics & Computer Science", pAge: "20 years old",
  editProfile: "Edit Profile", pQuote: "\"Better Learners, Brighter Futures\"",
  bioTitle: "Bio",
  bioText: "CS student at BUE, always curious, always learning. I love turning ideas into real projects, and I believe that learning should be fun (and a little bit of a game 😉).",
  interestsTitle: "Interests",
  favTitle: "Favorite Subject",
  prefTitle: "Preferences & Account",
  settingsT: "Settings", settingsD: "Manage account & notifications",
  privacyT: "Privacy", privacyD: "Control what you share",
  langT: "Language", logoutT: "Log Out", logoutD: "Sign out from this account",
  journeyStatsTitle: "Your Learning Journey", lvlName: "Explorer",
  streakDays: "days streak", achievements: "Achievements", certificates: "Certificates",
  aboutBannerT: "About Us", aboutBannerD: "Learn more about LUDUS and our mission",
  langSelfName: "English",
  loading: "Loading...", errorTitle: "Something went wrong", retry: "Retry",
  notAvailableYet: "Not available yet", notAvailableDesc: "We're preparing this page for you.",
  emptyTitle: "Nothing here yet",
  navScenarios: "Scenarios",
  scenariosTitle: "Scenario Learning",
  scenariosDesc: "Pick a scenario to start interactive learning — read, respond, get instant feedback.",
  scenarioEyebrow: "Real-world pharmacognosy situations", scenarioCount: "scenarios", instantFeedback: "Instant feedback",
  startScenario: "Start challenge", simpleSteps: "3 simple steps",
  scenarioStep1T: "Understand the situation", scenarioStep1D: "Read a realistic case and identify its key details.",
  scenarioStep2T: "Analyze and decide", scenarioStep2D: "Use your knowledge to answer the guiding question.",
  scenarioStep3T: "Learn from feedback", scenarioStep3D: "Get instant feedback and improve step by step.",
  scenariosHowTitle: "How it works",
  sessionTitle: "Learning Session",
  sessionEmptyTitle: "Pick a scenario first",
  sessionEmptyDesc: "Go back to scenarios and choose one to start.",
  backToScenarios: "Back to scenarios",
  contextLabel: "Context",
  challengeLabel: "Challenge",
  questionLabel: "Socratic question",
  answerPlaceholder: "Write your answer here...",
  submitBtn: "Submit answer",
  submitting: "Submitting...",
  stageLabel: "Stage",
  microLessonTitle: "Micro lesson",
  correctNoLesson: "Correct — no micro lesson needed.",
  reChallengeLabel: "Re-challenge",
  masteredTitle: "Mastered! 🎉",
  retryTitle: "Needs review",
  tryAgain: "Try again",
  botReplies: [
    "I'm just a demo bot for now 🙂 real AI chat is coming soon!",
    "Got it, noted — I'll build that feature out soon!",
    "Great idea, adding it to the list 📝",
  ],
};
